import { Injectable } from "@angular/core";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";
import { environment } from "../../../../environments/environment";
import { reject } from "q";

@Injectable()
export class ForgetPasswordService {
  constructor(private _circularInjectionHelper: CircularInjectionHelper) { }

  /**
   * Call method to send request to Srver to reset password
   * @param userName reset password for this userName
   */
  public SendForgetPasswordRequest(userName: string): Promise<void> {
    const me = this;
    return new Promise<void>(async (resolve, reject) => {
      try {
        const result = await me._circularInjectionHelper.yourAppServer.Api.ForgotPassword(userName);
        if (!result) {
          me._circularInjectionHelper.coreLogService.error("ForgetPasswordService.SendForgetPasswordRequest", "cant forgot password");
          return reject();
        }
        return resolve();
      } catch (error) {
        me._circularInjectionHelper.coreLogService.error("ForgetPasswordService.SendForgetPasswordRequest", "ForgotPassword() catch", error);
        return reject();
      }
    });
  }
}
